<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    value: {
      type: Object,
      required: true,
    },
  },
  watch: {
    value: {
      deep: true,
      handler(data) {
        this.setData(data);
      },
    },
  },
  data() {
    return {
      sum: 0,
      data: [],
      init: {
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
        xAxis: {
          axisLine: { show: false },
          splitLine: { show: false },
        },
        yAxis: {
          axisLine: { show: false },
          splitLine: { show: false },
        },
        tooltip: {
          trigger: 'item',
          transitionDuration: 0,
          formatter: '{b} : {c}',
          textStyle: {
            fontSize: 12,
          },
        },
      },
    };
  },
  computed: {
    options() {
      const options = {
        title: [
          {
            text: '{name|' + this.type + '}',
            top: '10%',
            left: 'center',
            textStyle: {
              rich: {
                name: {
                  fontSize: 14,
                  fontWeight: 'bold',
                  color: '#666666',
                  padding: [10, 0],
                },
                val: {
                  fontSize: 20,
                  fontWeight: 'bold',
                  color: '#6d717d',
                },
              },
            },
          },
          {
            text: '{val|' + this.sum + '}',
            top: 'center',
            left: 'center',
            textStyle: {
              rich: {
                name: {
                  fontSize: 14,
                  fontWeight: 'normal',
                  color: '#666666',
                  padding: [10, 0],
                },
                val: {
                  fontSize: 20,
                  fontWeight: 'bold',
                  color: '#6b717d',
                },
              },
            },
          },
        ],
        yAxis: [
          {
            axisLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: 'pie',
            center: ['50%', '50%'],
            label: { show: false },
            hoverAnimation: false,
            selectedMode: 'single',
            radius: '50%',
            // radius: ['50%', '100%'],
            data: this.data,
          },
        ],
      };
      return options;
    },
  },
  methods: {
    setData(data) {
      this.sum = Object.values(data).reduce((acc, val) => (acc += val), 0);
      this.data = Object.keys(data).map(name => ({
        name,
        value: data[name],
      }));
    },
  },
};
</script>
